<template>
  <div>
    <card class="mt-3">
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 mt-2">
          <strong>Goal Name</strong>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-10">
          <fg-input
            name="goalName"
            maxlength="20"
            :disabled="disableFields || readonly"
            v-model="ticketGoal.GoalName"
            @focus="onFocus('GoalName')"
            @blur="onBlur"
          />
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12">
          <p-button
            type="button"
            v-if="ticketGoal.TicketGoalStatus === 'PendingApproval' && displayScouterKey"
            class="float-right ml-2 mr-2"
            variant="success"
            @click="onClickChangeStateButton"
          >
            Approve
          </p-button>
          <p-button
            type="button"
            v-if="!displayScouterKey"
            :disabled="disableButtons"
            class="float-right ml-2 mr-2"
            variant="success"
            @click="onClickChangeStateButton"
          >
            {{ buttonText }}
          </p-button>
          <p-button
            type="button"
            :disabled="readonly"
            v-if="ticketGoal.TicketGoalStatus === 'InProgress' && !displayScouterKey"
            class="float-right ml-2 mr-2"
            variant="primary"
            @click="onClickReopenButton"
          >
            Re-Open Ticket
          </p-button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-lg-2 col-md-2 col-sm-2 text-danger h6">
          Ticket Goal
        </div>
        <label class="col-lg-10 col-md-10 col-sm-10">Write a short statement that gives a simple description or overview of this ticket goal.</label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Overview"
            max-length="1500"
            class="form-control answer"
            rows="3"
            :disabled="disableFields || readonly"
            @focus="onFocus('Overview')"
            @blur="onBlur"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Overview"
            max-length="1500"
            class="form-control answer"
            rows="9"
            :disabled="disableFields || readonly"
            @focus="onFocus('Overview')"
            @blur="onBlur"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 text-center mt-3">
          <h2>
            <strong>S</strong>
          </h2>
          <h6 class="text-danger">
            Specifi
          </h6>
        </div>
        <label
          class="col-lg-10 col-md-10 col-sm-10"
        >What exactly will you accomplish? Goals are clear, detailed, and
          unambiguous. A specific goal will usually answer the five "W"
          questions:
          <ul>
            <li>What: What do I want to accomplish?</li>
            <li>
              Why: Specific reasons, purpose, or benefits of accomplishing the
              goal
            </li>
            <li>Who: Who is involved?</li>
            <li>Where: Identify a location.</li>
            <li>Which: Identify requirements and constraints</li>
          </ul>
        </label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Specific"
            max-length="1500"
            class="form-control answer"
            rows="3"
            :disabled="disableFields || readonly"
            @focus="onFocus('Specific')"
            @blur="onBlur"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Specific"
            max-length="1500"
            class="form-control answer"
            rows="9"
            :disabled="disableFields || readonly"
            @focus="onFocus('Specific')"
            @blur="onBlur"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 text-center mt-3">
          <h2>
            <strong>M</strong>
          </h2>
          <h6 class="text-danger">
            Measurable
          </h6>
        </div>
        <label
          class="col-lg-10 col-md-10 col-sm-10"
        >This term stresses the need for concrete criteria for measuring
          progress toward the attainment of the goal. If a goal is not
          measurable, it is not possible to know whether progress toward
          successful completion is being made. A measurable goal will usually
          answer questions such as:
          <ul>
            <li>How much?</li>
            <li>How many?</li>
            <li>How will I know when itis accomplished?</li>
          </ul>
        </label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Measurable"
            max-length="1500"
            class="form-control answer"
            rows="3"
            :disabled="disableFields || readonly"
            @focus="onFocus('Measurable')"
            @blur="onBlur"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Measurable"
            max-length="1500"
            class="form-control answer"
            rows="9"
            :disabled="disableFields || readonly"
            @focus="onFocus('Measurable')"
            @blur="onBlur"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 text-center mt-3">
          <h2>
            <strong>A</strong>
          </h2>
          <h6 class="text-danger">
            Attainable
          </h6>
        </div>
        <label
          class="col-lg-10 col-md-10 col-sm-10"
        >This term stresses the importance of goals that are realistic and
          attainable. While an attainable goal may stretch the goal-setter to
          achieve it, the goal is not extreme. An attainable goal will usually
          answer questions such as:
          <ul>
            <li>How can this goal be accomplished?</li>
            <li>
              What kind of roadblocks might interfere, and how can they be
              overcome?
            </li>
          </ul>
        </label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Attainable"
            max-length="1500"
            class="form-control answer"
            rows="3"
            :disabled="disableFields || readonly"
            @focus="onFocus('Attainable')"
            @blur="onBlur"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Attainable"
            max-length="1500"
            class="form-control answer"
            rows="9"
            :disabled="disableFields || readonly"
            @focus="onFocus('Attainable')"
            @blur="onBlur"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 text-center mt-3">
          <h2>
            <strong>R</strong>
          </h2>
          <h6 class="text-danger">
            Relevant
          </h6>
        </div>
        <label
          class="col-lg-10 col-md-10 col-sm-10"
        >A relevant goal must represent an objective that the goal-setter is
          willing and able to work toward. A relevant goal will usually answer
          the questions:
          <ul>
            <li>Does this seem worthwhile?</li>
            <li>Why is this goal significant to my role in Scouting?</li>
          </ul>
        </label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Relevant"
            max-length="1500"
            class="form-control answer"
            rows="3"
            :disabled="disableFields || readonly"
            @focus="onFocus('Relevant')"
            @blur="onBlur"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Relevant"
            max-length="1500"
            class="form-control answer"
            rows="9"
            :disabled="disableFields || readonly"
            @focus="onFocus('Relevant')"
            @blur="onBlur"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2 text-center mt-3">
          <h2>
            <strong>T</strong>
          </h2>
          <h6 class="text-danger">
            Timely
          </h6>
        </div>
        <label
          class="col-lg-10 col-md-10 col-sm-10"
        >When will you achieve this goal? A commitment to a deadline helps
          focus efforts on completion of the goal on or before the due date. A
          timely goal will usually answer questions such as "when":
          <ul>
            <li>What can I do 5 months from now?</li>
            <li>What can I do 12 months from now?</li>
            <li>What can I do today?</li>
          </ul>
        </label>
      </div>
      <div class="row form-group">
        <div class="col-lg-12 col-md-12 d-none d-md-block">
          <textarea
            v-model="ticketGoal.Timely"
            max-length="1500"
            @focus="onFocus('Timely')"
            :disabled="disableFields || readonly"
            @blur="onBlur"
            class="form-control answer"
            rows="3"
          />
        </div>
        <div class="col-sm-12 d-md-none">
          <textarea
            v-model="ticketGoal.Timely"
            max-length="1500"
            @focus="onFocus('Timely')"
            :disabled="disableFields || readonly"
            @blur="onBlur"
            class="form-control answer"
            rows="9"
          />
        </div>
      </div>
    </card>
    <card>
      <div class="row mt-3">
        <div class="col-lg-6 col-md-6 col-sm-6">
          Does this goal Promote Diversity?
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 text-right">
          <p-switch
            v-model="ticketGoal.PromotesDiversity"
            :disabled="disableFields || readonly"
            type="primary"
            on-text="YES"
            off-text="NO"
            @change="onRadioChanged"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          Does this goal Promote Membership Growth and Retention?
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 text-right">
          <p-switch
            v-model="ticketGoal.PromotesMembership"
            :disabled="disableFields || readonly"
            type="primary"
            on-text="YES"
            off-text="NO"
            @change="onRadioChanged"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6">
          Does this goal Show a Line of Sight to the Youth?
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 text-right">
          <p-switch
            v-model="ticketGoal.ShowsLineOfSight"
            :disabled="disableFields || readonly"
            type="primary"
            on-text="YES"
            off-text="NO"
            @change="onRadioChanged"
          />
        </div>
      </div>
      <div
        v-if="ticketGoal.ApprovalDate"
        class="row"
      >
        <div class="col-lg-12 col-md-12 col-sm-12">
          Ticket Approved By {{ ticketGoal.ApprovedByScouterKey }} On
          {{ ticketGoal.ApprovalDate }}.
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import ticketGoalApi from '@/services/api/ticket'
import pSwitch from '@/plugins/paper-components/p-switch.vue'

export default {
  name: 'TicketGoal',
  components: {
    pSwitch
  },
  props: {
    ticketGoal: {
      type: Object,
      default: function () {
        return {}
      }
    },
    statuses: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: null
    },
    displayScouterKey: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      goal: null,
      loading: true,
      errormessage: null,
      currentFieldValue: null,
      currentFieldName: null,
      buttonText: null,
      disableButtons: false,
      disableFields: false
    }
  },
  watch: {
    ticketGoal: function () {
      this.setupPageState()
    }
  },
  mounted: function () {
    this.goal = this.ticketGoal
    this.setupPageState()
  },
  methods: {
    onFocus: function (fieldName) {
      // This is part 1 of 2 parts of the hack, but it is is the best I have right now
      this.currentFieldValue = this.ticketGoal[fieldName]
      this.currentFieldName = fieldName
    },
    onBlur: function () {
      // This is part 2 of 2 parts of the hack, but it is is the best I have right now
      if (this.currentFieldValue !== this.ticketGoal[this.currentFieldName]) {
        this.updateTicketGoal()
      }
    },
    onRadioChanged: function () {
      this.updateTicketGoal()
    },
    updateTicketGoal: function () {
      ticketGoalApi
        .updateTicketGoal(this.ticketGoal)
        .then(x => {
          if (x.ResultCode === 'Success') {
            this.$emit('ticket-updated')
          }
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating your ticket goal.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
    },
    onClickReopenButton: function () {
      const msg =
        'Are you sure you want to reopen this Goal?  This will cause the Goal to need to ' +
        'be approved again.  This can become necssary if you need to change your goal due ' +
        'to a change in circumstances or attainability.  Contact your Ticket Coordinator to ' +
        'assist with getting the goal changes approved.  Would you like to continue?'
      const title = 'Are you sure?'
      this.$confirm(msg, title, {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.ticketGoal.TicketGoalStatus = 'PendingApproval'
        this.updateTicketGoal()
      })
    },
    onClickChangeStateButton: function () {
      switch (this.ticketGoal.TicketGoalStatus) {
        case 'New':
          this.ticketGoal.TicketGoalStatus = 'PendingApproval'
          break
        case 'PendingApproval':
          this.ticketGoal.TicketGoalStatus = 'InProgress'
          break
        case 'InProgress':
          this.ticketGoal.TicketGoalStatus = 'Completed'
          break
        case 'Completed':
          break
      }
      this.updateTicketGoal()
    },
    setupPageState: function () {
      switch (this.ticketGoal.TicketGoalStatus) {
        case 'New':
          this.disableButtons = false
          this.disableFields = false
          this.buttonText = 'Start by creating an Overview'
          break
        case 'PendingApproval':
          this.disableButtons = true
          this.disableFields = false
          this.buttonText = 'Waiting for Approval'
          break
        case 'InProgress':
          this.disableButtons = false
          this.disableFields = true
          this.buttonText = 'Mark Complete'
          break
        case 'Completed':
          this.disableButtons = true
          this.disableFields = true
          this.buttonText = 'Much Success!'
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  margin-right: 10px;
}

@media (max-width: 768px) {
  .answer {
    max-height: none;
  }
}
</style>
